<!-- 
  详情页 - 开票历史
  props:
    id: 详情id
  emit:
    openDetail: 打开详情页
 -->

<template>
	<div class="v-tabs notes-list">
		<div class="head">
      <div class="total">
        累计{{page.total}}次开票  开票总金额 <span class="red">{{allTotalMoney}}</span> 元
      </div>
      <div class="inline-item">
        <el-date-picker
          v-model="date"
          @change="datepicker"
          size="small"
          value-format="yyyy-MM-dd"
          type="daterange"
          style="width:180px"
          unlink-panels
          start-placeholder="开始时间"
          end-placeholder="结束时间">
        </el-date-picker>
      </div>
      <div class="inline-item">
        <el-button size="small" type="primary" @click="addNew" v-if="moduleName !== 'paymentApi' && InvoiceAdd">新建发票</el-button>
      </div>
    </div>
    <div class="content" ref="content">
      <ul class="item-list">
        <li class="item center" v-if="!tableData.length">暂无数据</li>
        <li class="item" v-for="item in tableData">
          <span class="date">{{item.invoiceDate}}</span>
          <div class="order">
            <div class="head-top">
              <div class="id">
                <i class="ico purple">票</i>
                <a @click="openDetail(item.id)" class="link" :class="{red: item.isRed}">{{item.sheetNo}}</a>
              </div>
              <span v-if="item.isMerge">合并开票</span>
            </div>
            <div class="good">
              <span class="thumb">
                <i class="web-icon-dollar-circle"></i>
              </span>
              <span class="title">{{item.totalMoney}}{{item.unit}}</span>
            </div>
            <div class="response">申请人：{{item.userName}}</div>
          </div>
        </li>
      </ul>
    </div>
    <div class="load-more">
      <template v-if="showLoadmore">
        <i class="el-icon-loading"></i>
        加载更多
      </template>
      <template v-if="!showLoadmore && page.total>page.size">没有更多</template>
    </div>

    <add-new
      ref="addNew"
      v-if="addnewShow"
      :modal="false"
      :addnewProp="addnewProp"
      @refresh="refresh"
      @closeForDetail="addnewShow=false">
    </add-new>
	</div>
</template>

<script>
import Vue from 'vue'
import * as api from 'src/api'
import addNew from 'components/modal/add-new'
import { mapActions } from 'vuex'

export default {
  props: {
    id: {
      type: Number
    },
    moduleName: {
      type: String
    },
    loading: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      tableData: [],
      date: [],
      // 分页信息
      page: {
        size: 10,
        total: '',
        page: 1,
        rows: 1
      },
      allTotalMoney: 0, // 开票总金额
      addnewShow: false,
      addnewProp: {
        refIds: [this.id],
        module: 'invoice',
        type: this.moduleName
      },
      InvoiceAdd: true
    }
  },
  computed: {
    // 是否显示加载更多
    showLoadmore () {
      if (this.page.total > this.page.size && this.page.rows > this.page.page) {
        return true
      } else {
        return false
      }
    }
  },
  created () {
    this.getList()
  },
  methods: {
    ...mapActions([
      'setSortObj'
    ]),
    datepicker (val) {
      this.page.page = 1
      if (val) {
        this.date = val
      } else {
        this.date = []
      }
      this.getList()
    },
    openDetail (id) {
      this.$emit('openDetail', 'invoice', id)
    },
    getList () {
      const time = this.date && this.date.length && this.date[0]
      let url = '/invoice/getInvoices.html'
      let params = {
        refId: this.id,
        refType: this.moduleName.replace('Api', ''),
        invoiceDate: time ? this.date : [],
        page: this.page.page,
        pageSize: this.page.size
      }
      api.post(url, params, (data) => {
        this.page.total = data.pageHelper.rowsCount
        this.page.rows = data.pageHelper.pageTotal
        this.allTotalMoney = data.allTotalMoney // 开票总金额
        this.InvoiceAdd = data.InvoiceAdd

        // 通过page.page来判断当前是刷新还是下拉加载更多
        if (this.page.page === 1) {
          this.tableData = data.result
        } else {
          this.tableData = this.tableData.concat(data.result)
        }
      })
    },
    // 加载更多
    loadmore () {
      this.page.page++
      this.getList()
    },
    // 新建发票
    addNew () {
      Vue.set(this.addnewProp, 'id', '')
      this.openAddNew()
    },
    // 打开 addnew 弹窗
    openAddNew () {
      this.addnewShow = true
      this.$nextTick(() => {
        this.$refs.addNew.dialogFormVisible = true
      })
    },

    // 发票新建成功，刷新页面
    refresh () {
      this.getList()

      // 刷新父级列表页
      this.setSortObj({})
    }
  },
  watch: {
    loading () {
      if (this.page.rows > this.page.page) {
        this.loadmore()
      }
    }
  },
  components: {
    addNew
  }
}
</script>

<style lang="less" scoped>
  .notes-list {
    .head-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-right: 10px;
      .id{
        a{
          width: auto!important;
        }
      }
    }
    .head {
      .red {
        color: red;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// invoice-history.vue?2caa22e9